import { Container, FullScreenLoading } from '@bfa/common-ui';
import Head from 'next/head';
import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import styled from 'styled-components';

import Error from '../../../../components/Error';
import Layout from '../../../../components/Layout';
import useGetTerms from './hooks/useGetTerms';

const StyledContainer = styled(Container)`
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    margin-bottom: 3rem;
  }
`;

const Terms = () => {
  const { loading, error, navBar, userId, giftingTerms } = useGetTerms();

  if (error) {
    return <Error />;
  }

  if (loading) {
    return <FullScreenLoading loading />;
  }

  return (
    <Layout
      header={{
        user: { id: userId },
        activeTab: '',
        refreshmentsShowLabel: false,
        showSecure: false,
        ...navBar,
      }}
      footer
    >
      <Head>
        <title>Gifting | IPSY</title>
        {/* TODO: Add meta data */}
        <meta name="description" content="Gift redemption page for pinks." />
      </Head>
      <StyledContainer width="100%" pt={['2.9rem', '2.3rem']} pb="6.7rem">
        {ReactHtmlParser(giftingTerms)}
      </StyledContainer>
    </Layout>
  );
};

export default Terms;
